import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InputForm from '../InputForm';
import useEscaneosStore from '../../store/escaneosStore';
import CouponList from '../coupons/CouponList';
import SelectMultiForm from '../SelectMultiForm';

const FormEscaneos = () => {
    const navigate = useNavigate();
    const { datos, handleChange, handleSave, nombre_cliente, nombre_usuario, fecha, fecha_alta, descuentos, promociones, sucursales, handleSucursales, sucursalesEscaneo } = useEscaneosStore();
    const [disabledButton, setDisabledButton] = useState(false);
    const goBack = () => navigate(-1);

    const handleValidarYGuardar = () => {
        if (!datos.consumo || datos.consumo.toString().trim() === "") {
            window.notie.alert({ type: 'warning', text: 'El campo Folio no puede estar vacío' });
            return;
        }
        if (!datos.total_gasto || Number(datos.total_gasto) === 0) {
            window.notie.alert({ type: 'warning', text: 'El campo Total Gasto no puede estar vacío o en cero' });
            return;
        }
        /* if (!datos.id_sucursal || Number(datos.id_sucursal) === 0) {
            window.notie.alert({ type: 'warning', text: 'Debe seleccionar una sucursal' });
            return;
        } */
        
        handleSave();
    };

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden">
            <div className="card-body p-40">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="col-12">
                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                Nombre cliente: {nombre_cliente}
                            </label>
                        </div>
                        <div className="col-12">
                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                Escaneado por: {nombre_usuario}
                            </label>
                        </div>
                        <div className="col-12">
                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                Ultimo cambio: {fecha}
                            </label>
                        </div>
                        <div className="col-12">
                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                Fecha Alta: {fecha_alta}
                            </label>
                        </div>
                        <InputForm
                            name="consumo"
                            label="Folio"
                            datos={datos}
                            change={handleChange}
                            required
                        />
                        <InputForm
                            name="total_gasto"
                            label="Total Gasto"
                            esNumeroConDecimales={true}
                            datos={datos}
                            change={handleChange}
                            required
                        />
                        <div className="col-12">
                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                Sucursal: {datos.id_sucursal != 0 && sucursalesEscaneo?.label ? sucursalesEscaneo.label : "No seleccionado"}
                            </label>
                        </div>
                        <InputForm
                            name="motivo"
                            label="Motivo (opcional)"
                            datos={datos}
                            change={handleChange}
                            type="textarea"
                        />
                        {/* <SelectMultiForm
                            col="col-sm-12"
                            datos={sucursales} 
                            change={handleSucursales}
                            values={sucursalesEscaneo}
                            placeholder="Seleccione una o varias sucursales"
                            name="sucursalesEscaneo"
                            isMulti={false}
                            // error={error}
                        /> */}
                        {/* <InputForm
                            name="total_descuento"
                            label="Total Descuento"
                            esNumeroConDecimales={true}
                            datos={datos}
                            change={handleChange}
                            required
                        /> */}

                        {
                            descuentos.length > 0 &&
                            <div className="mt-2">
                                <h6 className="mb-3">Descuentos Aplicados</h6>
                                {
                                    descuentos.map((item, index) => (
                                        <div key={index}>
                                            <p>{item.TITULO_CUP} - {item.VALOR_CUP} de descuento</p>

                                        </div>
                                    ))
                                }
                            </div>
                        }

                        
                        
                        {
                            promociones.length > 0 &&
                            <div className="mt-2">
                                <h6 className="mb-3">Promociones Aplicadas</h6>
                                {
                                    promociones.map((item, index) => (
                                        <div key={index}>
                                            <p>{item.TITULO_CUP}</p>

                                        </div>
                                    ))
                                }
                            </div>
                        }
                         
                        
                        {/* Coupon List Section */}
                        <div className="mt-5">
                            <CouponList />
                        </div>

                        <div className="row mt-5">
                            <div className="d-flex align-items-center justify-content-between gap-3 mt-24">
                                <button
                                    onClick={goBack}
                                    type="reset"
                                    className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                                >
                                    Cancelar
                                </button>
                                <button
                                    disabled={disabledButton}
                                    onClick={handleValidarYGuardar}
                                    className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                                >
                                    Guardar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormEscaneos;